import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const RepositoriosController = {
  async ListRepositorios() {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `repo_page/listrepos`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async AddRepositorios(newRepoName, esterioValue, esterioOptionValue, newPromptName) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `repo_page/`, {
        reponame: newRepoName,
        esterio: esterioValue,
        esterio_side: esterioOptionValue,
        prompt: newPromptName
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  },
  async PutRepositorios(Id, reponame, prompt) {
    try {
      const response = await axios.put(
        `${AppConfig.BACKEND_URL_REFATORADO}repo_page/${Id}`,
        { reponame , prompt },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  },
  async DeleteRepositorios(Id) {
    try {
      const response = await axios.delete(
        `${AppConfig.BACKEND_URL_REFATORADO}repo_page/${Id}`, 
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },
};

export default RepositoriosController;